import Wrapper from './Wrapper';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import SimulateChat from './SimulateChat';

const ChatSimulation = () => {
    const params = useParams();
    const location = useLocation();
    const agentId = params.id as string;
    const { pathname } = location;
    return (
        <Wrapper title='Chat Simulation' description={`Test your AI agent's responses`}>
            {agentId && <SimulateChat agentId={parseInt(agentId)} pathname={pathname} />}
        </Wrapper>
    );
};

export default ChatSimulation;
